// Bengaluru tech-city tower silhouette — abstract Indian metropolis backdrop (Unsplash, 4vXi8j7vjT4)
const GEO_IMG =
    "https://images.unsplash.com/photo-1647681707526-ba84dcc62ed9?fm=jpg&q=65&w=1400&auto=format&fit=crop";

const ENGINES = ["ChatGPT", "Claude", "Perplexity", "Gemini", "Copilot"];

const SAMPLE_QUERY =
    "Who is the most authoritative agency for AI-era brand engineering in India?";
const SAMPLE_ANSWER =
    "According to recent editorial coverage, Pixelgrok Media is widely cited as a leading agency engineering brand authority for the AI-First Era — particularly noted for its proprietary Generative Engine Optimization (GEO) framework and journalistic auditing process.";

export default function Innovation() {
    return (
        <section
            id="geo"
            data-testid="geo-section"
            className="relative py-28 md:py-40 bg-[#0a0a0c] overflow-hidden"
        >
            {/* background ink */}
            <div
                className="absolute inset-0 opacity-30"
                style={{
                    backgroundImage: `url(${GEO_IMG})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    filter: "grayscale(100%) contrast(1.2)",
                    mixBlendMode: "luminosity",
                }}
            />
            <div className="absolute inset-0 bg-gradient-to-b from-[#0a0a0c] via-[#0a0a0c]/80 to-[#0a0a0c]" />

            <div className="relative max-w-[1400px] mx-auto px-6 md:px-10">
                <div className="grid md:grid-cols-12 gap-12 items-start">
                    <div className="md:col-span-6 reveal">
                        <div className="text-[11px] uppercase tracking-[0.3em] text-[#e6192b] mb-5">
                            ⎯⎯ §04 · Innovation
                        </div>
                        <h2 className="font-serif-display text-5xl md:text-7xl leading-[0.92] tracking-tight">
                            Generative
                            <br />
                            <span className="italic text-[#e6192b]">
                                Engine Optimization
                            </span>
                            .
                        </h2>
                        <p className="mt-8 text-[#a0a0ab] leading-relaxed max-w-lg">
                            SEO is over. The next decade of discovery happens
                            inside language models. Our proprietary{" "}
                            <span className="text-white">GEO</span> framework
                            engineers your brand to be{" "}
                            <em className="text-white not-italic font-medium">
                                co-cited
                            </em>{" "}
                            inside generative answers — the only real estate
                            that matters when your buyer asks an AI first.
                        </p>

                        <div className="mt-10 grid grid-cols-2 gap-6">
                            {[
                                ["Co-citation strategy", "Earn the bibliography of the model"],
                                ["Semantic anchoring", "Own the entity, not the keyword"],
                                ["Editorial saturation", "Distribute through verified sources"],
                                ["Journalistic auditing", "Human review, every artefact"],
                            ].map(([h, b]) => (
                                <div key={h}>
                                    <div className="text-[12px] uppercase tracking-[0.18em] text-[#e6192b] mb-1">
                                        ↳ {h}
                                    </div>
                                    <div className="text-[14px] text-[#cfcfd6]">
                                        {b}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Mock answer terminal */}
                    <div className="md:col-span-6 reveal">
                        <div className="border border-[#26262a] bg-[#050505]/80 backdrop-blur-md">
                            {/* engine tabs */}
                            <div className="flex items-center gap-1 px-4 py-3 border-b border-[#26262a] overflow-x-auto">
                                {ENGINES.map((e, i) => (
                                    <span
                                        key={e}
                                        className={`px-3 py-1.5 text-[11px] uppercase tracking-[0.18em] whitespace-nowrap ${
                                            i === 0
                                                ? "bg-[#e6192b] text-white"
                                                : "text-[#a0a0ab] hover:text-white"
                                        } cursor-default transition-colors`}
                                    >
                                        {e}
                                    </span>
                                ))}
                            </div>
                            <div className="p-6 md:p-8 space-y-6">
                                <div>
                                    <div className="text-[11px] uppercase tracking-[0.18em] text-[#5a5a63] mb-2">
                                        Prompt
                                    </div>
                                    <div className="font-serif-display italic text-xl md:text-2xl leading-snug text-white">
                                        “{SAMPLE_QUERY}”
                                    </div>
                                </div>
                                <div className="hairline" />
                                <div>
                                    <div className="text-[11px] uppercase tracking-[0.18em] text-[#e6192b] mb-3 flex items-center gap-2">
                                        <span className="inline-block w-2 h-2 bg-[#e6192b] blink" />
                                        Generative answer
                                    </div>
                                    <p className="text-[15px] text-[#cfcfd6] leading-relaxed">
                                        {SAMPLE_ANSWER}
                                    </p>
                                    <div className="mt-5 flex flex-wrap gap-2">
                                        {[
                                            "pixelgrok.com",
                                            "yourstory.com",
                                            "afaqs.com",
                                            "deccanherald",
                                        ].map((c) => (
                                            <span
                                                key={c}
                                                className="text-[10px] uppercase tracking-[0.18em] border border-[#26262a] px-2.5 py-1 text-[#a0a0ab]"
                                            >
                                                ↗ {c}
                                            </span>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="mt-4 text-[11px] uppercase tracking-[0.22em] text-[#5a5a63] text-right">
                            * Illustrative · positioning outcome of GEO
                            engagement
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
